/**
 * Caching contract for the Performance surface (#6293).
 *
 * Report data is served from cache for an hour: tab switches remount panels,
 * and the old 5-minute staleTime PLUS React Query's default 5-minute gcTime
 * (unobserved caches are garbage-collected once every panel using them
 * unmounts) meant almost every tab click refired live GAQL. Filter changes
 * still fetch immediately — a new filter value is a new query key. The
 * manual Refresh control invalidates the whole family below.
 */

export const PERF_STALE_TIME_MS = 60 * 60 * 1000;
// gcTime must OUTLIVE staleTime or unmount-then-remount evicts the cache
// regardless of freshness — the actual cause of the per-tab-click refetches.
export const PERF_GC_TIME_MS = 65 * 60 * 1000;

const PERF_KEY_ROOTS = new Set([
  'performance-timeseries',
  'performance-timeseries-previous',
  'ad-performance-report',
  'campaign-status-report',
  'keywords-overview-report',
  'landing-page-experience',
  'account-search-terms-report',
  'activity-feed',
  'performance-insights',
  'top-recommendations',
  'conversion-actions-report',
  'demographics-report',
  'geography-report',
  'device-report',
]);

/** True for every query the Performance surface's Refresh control should invalidate. */
export function isPerfQueryKey(key: readonly unknown[]): boolean {
  const [root, second] = key;
  if (typeof root !== 'string') return false;
  if (PERF_KEY_ROOTS.has(root)) return true;
  if (root === 'actionLogs' && second === 'all') return true;
  if (root === 'meta' && second === 'dashboards') return true;
  return false;
}
